import { generatePath } from 'react-router';
import {
    LoadingSpinnerPresets,
    PresetLoadingSpinner,
} from 'dg-web-shared/common/components/material-ui/PresetLoadingSpinner';
import {
    RequestStatus,
    useNavigateOnError,
    useNavigateOnSuccess,
    useServerSuccessEffect,
    useServerWrite,
} from 'dg-web-shared/lib/hooks/ServerStateHooks';
import { useParamOrNull } from 'dg-web-shared/lib/ReactRouterHelpers';
import { useEffect } from 'react';

export function EmailVerificationRoute({
    refetchUser,
}: {
    refetchUser?: () => void;
}) {
    const token = useParamOrNull('token') ?? '';

    const [submitState, submit] = useServerWrite<{ token: string }, never>(
        () => ({
            url: '/ui-api/parkingabo/user/confirm',
        }),
    );

    useEffect(() => {
        if (token && submitState.status === RequestStatus.NEVER_EXECUTED) {
            submit({ token });
        }
    }, [submitState, submit, token]);

    useNavigateOnSuccess(submitState, '/login/email-confirmed');
    useServerSuccessEffect(submitState, refetchUser ? refetchUser : () => null);

    useNavigateOnError(
        submitState,
        generatePath('/link-expired/:token', { token }),
    );

    return (
        <PresetLoadingSpinner
            preset={LoadingSpinnerPresets.FillAllSpaceAndCenter}
        />
    );
}
